import React, { Component, Fragment } from 'react';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import { Modal } from 'react-bootstrap';
import logo from '../../static/images/logo-countpicula-dark.png';
import { upload_steps } from '../../utils/upload';
import 'react-image-crop/dist/ReactCrop.css';
import { connect } from 'react-redux';
import { buy } from '../../store/actions';

class CropModalClass extends Component {
  state = {
    crop: {},
    pixelCrop: {}
  };

  onChange = (crop, pixelCrop) => {
    if (crop.width === 0 || crop.height === 0) {
      return;
    }
    this.setState({ crop, pixelCrop });
  };

  setCropPosition = (imageWidth, imageHeight, x = 0, y = 0) => {
    const {
      metaData: { ratiowidth, ratioheight }
    } = this.props;
    const aspect = ratiowidth / ratioheight;
    let widthPercentage = 100;
    let xPercentage = 0;
    let width = imageWidth;
    let height = imageHeight;
    if (imageHeight < (imageWidth * ratioheight) / ratiowidth) {
      width = (imageHeight * ratiowidth) / ratioheight;
      widthPercentage = (width / imageWidth) * 100;
      x = (imageWidth - width) / 2;
      xPercentage = (100 - widthPercentage) / 2;
    } else {
      height = (imageWidth * ratioheight) / ratiowidth;
    }
    return { x, y, width, height, aspect, widthPercentage, xPercentage };
  };

  onImageLoaded = image => {
    const {
      xPercentage: x,
      y,
      aspect,
      widthPercentage: width
    } = this.setCropPosition(image.width, image.height);
    this.setState({
      crop: makeAspectCrop(
        {
          x,
          y,
          aspect,
          width
        },
        image.width / image.height
      )
    });
  };

  getCroppedImage = async () => {
    const { file_data } = this.props;
    const image = document.createElement('img');
    image.src = file_data;
    const { y, x, width, height } = this.state.pixelCrop.width
      ? this.state.pixelCrop
      : this.setCropPosition(image.width, image.height);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
    const dataUrl = canvas.toDataURL('image/jpeg');
    const result = await fetch(dataUrl);
    return result.blob();
  };

  cropComplete = async () => {
    const {
      dispatch,
      buyStatus,
      file_data,
      template_key,
      handleClose
    } = this.props;
    if (buyStatus === buy.types.COMPLETE) {
      dispatch(buy.ready());
    }
    const file = await this.getCroppedImage(file_data);
    upload_steps(file, template_key, dispatch);
    handleClose();
  };

  render() {
    const { show, handleClose, file_data } = this.props;
    return (
      <Fragment>
        {show && (
          <Modal show={show} onHide={handleClose} bsSize="large">
            <Modal.Header closeButton>
              <div>
                <h2 className="modal-title" id="m_crop">
                  <span>Crop your image</span>
                </h2>
                <img
                  className="logo-img"
                  src={logo}
                  width="117"
                  height="75"
                  alt=""
                />
              </div>
            </Modal.Header>
            <Fragment>
              <div className="modal-body">
                <div className="confirm-img">
                  <ReactCrop
                    src={file_data}
                    onChange={this.onChange}
                    crop={this.state.crop}
                    onImageLoaded={this.onImageLoaded}
                    keepSelection={true}
                    minWidth={1}
                    minHeight={1}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <div className="footer-buttons">
                  <button
                    type="button"
                    className="btn btn-default btn-bevel"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-bevel"
                    onClick={this.cropComplete}
                  >
                    Crop image
                  </button>
                </div>
              </div>
            </Fragment>
          </Modal>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  upload_url: state.uploads.upload_url,
  upload_key: state.uploads.upload_key,
  preview_key: state.uploads.preview_key,
  preview_url: state.uploads.preview_url,
  file_data: state.uploads.file_data,
  template_key: state.uploads.template_key,
  metaData: state.uploads.templateMetaData.Metadata,
  buyStatus: state.buy.status
});

const CropModal = connect(mapStateToProps)(CropModalClass);

export default CropModal;



// WEBPACK FOOTER //
// ./src/comps/Feature/CropModal.js